import { configureStaticOSS } from "./oss";

export function initializeServices() {
  // 初始化 OSS
  configureStaticOSS({
    accessKeyId: import.meta.env.VITE_OSS_ACCESS_KEY_ID,
    accessKeySecret: import.meta.env.VITE_OSS_ACCESS_KEY_SECRET,
    region: import.meta.env.VITE_OOS_REGION,
    bucket: import.meta.env.VITE_OSS_BUCKET,
  });

  // 将来可以在这里初始化其他服务...
}
